import type { TypeProductCardDetailed } from 'types/autogen/contentful';
import { ProductItem, ProductSlider } from 'components';
import { withErrorBoundary } from 'react-error-boundary';
function ProductCard(props: TypeProductCardDetailed) {
    const { productList } = props.fields;

    if (!productList?.length) return null;

    if (productList.length > 1) return <ProductSlider items={productList} />;

    return <ProductItem model={productList[0]} />;
}

export default withErrorBoundary(ProductCard, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
